<template>
    <div class="shop-users clearfix">
        <div v-if="itemRow.total > 0 && itemRow.total <=3 &&itemRow.datas.length>0">
        <el-tooltip
                :content="`${item.name} ( ${item.account}  )`"
                :key="item.account_no?item.account_no:Math.random()"
                placement="top"
                v-for="item in itemRow.datas"
                
        >
            <el-button class="btn-dark user-item" @click="openForceExitDialog" v-if="item.account_no!==undefined">{{item.account_no.length>2?getNo(item.account_no):item.account_no}}</el-button>
        </el-tooltip>
        </div>
        <div v-if="itemRow.total > 3">
        <el-tooltip
                :content="`${item.name} ( ${item.account}  )`"
                :key="item.account_no?item.account_no:Math.random()"
                placement="top"
                v-for="item in totalData"
                
        >
            <el-button class="btn-dark user-item" @click="openForceExitDialog" v-if="item.account_no!==undefined">{{item.account_no.length >2?getNo(item.account_no):item.account_no}}</el-button>
        </el-tooltip>
        </div>
        <div class="btn-dark user-item" slot="reference" v-if="itemRow.total > 3&& itemRow.total < 103">
            <el-tooltip
                    placement="top"
                    v-if="totalDatas.length>=8"
            >
                <div style="max-height: 200px;height: 200px" slot="content">
                    <el-scrollbar style="height:100%;">
                        <div v-for="userItem in totalDatas"  style="margin: 8px 0;" :key="userItem.account_no?userItem.account_no:Math.random()">
                            <span>{{userItem.name}} ( {{userItem.account}}  )</span>
                        </div>
                    </el-scrollbar>
                </div>
                <el-button class="btn-dark user-item" @click="openForceExitDialog" >+{{itemRow.total-3}}</el-button>
            </el-tooltip>
            <el-tooltip
                    placement="top"
                    v-if="totalDatas.length<8"
            >
                <div slot="content">
                    <div v-for="userItem in totalDatas"  style="margin: 8px 0;" :key="userItem.account_no?userItem.account_no:Math.random()">
                        <span>{{userItem.name}} ( {{userItem.account}}  )</span>
                    </div>
                </div>
                <el-button class="btn-dark user-item" @click="openForceExitDialog" >+{{itemRow.total-3}}</el-button>
            </el-tooltip>
        </div>
        <div class="btn-dark user-item" slot="reference" v-if="itemRow.total >= 103">
            <el-tooltip
                    placement="top"
            >
                <div style="max-height: 200px;height: 200px" slot="content">
                    <el-scrollbar style="height:100%;">
                        <div v-for="userItem in totalDatas"  style="margin: 8px 0;" :key="userItem.account_no?userItem.account_no:Math.random()">
                            <span >{{userItem.name}} ( {{userItem.account}}  )</span>
                        </div>
                    </el-scrollbar>
                </div>
                <el-button class="btn-dark user-item" @click="openForceExitDialog" >+99</el-button>
            </el-tooltip>
        </div>
<!--        <span class="btn-dark user-item" slot="reference" v-if="itemRow.total > 5">...</span>-->
        <span v-if="no_one"></span>
    </div>
</template>

<script>
    export default {
        name: "ShopOnline",
        props: ['online'],
        data() {
            return {
                no_one: true,
                totalData:[],
                totalDatas:[],
            }
        },
        computed: {
            itemRow: function () {
                if ( this.online.total>=3){
                    let datas_one = [];
                    let datas_up3 = [];
                    for (let i = 0;i<3;i++){
                        datas_one.push(this.online.datas[i])
                    }
                    this.totalData = datas_one;
                    for (let j=3;j<this.online.total;j++){
                        datas_up3.push(this.online.datas[j])
                    }
                    this.totalDatas = datas_up3;
                }
                return this.online;
            }
        },
        methods:{
            getNo(account_no){
                return account_no.substring(account_no.length-3,account_no.length)
            },
            openForceExitDialog(){
                this.$emit('openForceDialog')
            }
        },
        watch: {
            'itemRow.total': function (value) {
                this.no_one = value === 0;
                if (value>=3){
                    let datas = [];
                    let datas_up3 = [];
                    for (let i = 0;i<3;i++){
                        datas.push(this.itemRow.datas[i])
                    }
                    this.totalData = datas;
                    for (let j=3;j<value;j++){
                        datas_up3.push(this.itemRow.datas[j])
                    }
                    this.totalDatas = datas_up3;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.el-scrollbar__wrap) {
        overflow-x: hidden;
    }
    .shop-users {
        height: 24px;
    }
    .clearfix {
        width: auto;
    }

    .user-item {
        float: left;
        display: inline-block;
        margin: 0 2px 0 0 !important;
        padding: 0;
        width: 28px;
        height: 28px;
        /*background-color: #3f5767;*/
        font-size: 12px;
        /*color: #aec7da;*/
        /*font-weight: 600;*/
        border-radius: 50%;

        &:hover {
            border-color: #c4c9cd;
        }
    }

</style>